import React, { useState, useEffect } from 'react';
import { getCosts } from '../../services/dashApiService';
import { CostItem } from './CostItem';
import {
  getTime,
  startOfDay,
  endOfDay,
  startOfMonth,
  lastDayOfMonth,
  subMonths,
  format
} from 'date-fns';
import { TransitionSlideUp } from '../transitions/TransitionSlideUp';
import { TransitionConfig } from '../../configs/transitionConfig';
import { LoadingSpinnerAlt } from '../common/LoadingSpinnerAlt';

export const YourCosts = ({ filter, onTotalCostsChange, onMonthChange, shouldUpdate, onUpdateFinish, onShowCost }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const thisMonthStart = getTime(startOfDay(startOfMonth(Date.now())));
  const thisMonthEnd = getTime(endOfDay(lastDayOfMonth(Date.now())));
  const thisMonthFilter = {
    start: thisMonthStart,
    end: thisMonthEnd
  };

  const lastMonthStart = getTime(startOfDay(startOfMonth(subMonths(Date.now(), 1))));
  const lastMonthEnd = getTime(endOfDay(lastDayOfMonth(subMonths(Date.now(), 1))));
  const lastMonthFilter = {
    start: lastMonthStart,
    end: lastMonthEnd
  };

  const [costItems, setCostItems] = useState([]);
  useEffect(() => {
    let didCancel = false;
    if (shouldUpdate === true) {
      setIsLoading(true);
  
      const {start, end} = filter === 'thisMonth' ? thisMonthFilter : lastMonthFilter;
  
      getCosts(start, end).then((result) => {
        if (!didCancel) {
          if (result.success) {
            const data = result.data.data;
            
            let total = 0;
            data.forEach(element => { total += element.amount; });
  
            const toFixed = (num, fixed) => {
              var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
              return num.toString().match(re)[0];
            }
  
            onTotalCostsChange(toFixed(total, 2));
  
            setCostItems(data);
            handleUpdateFinish(false);
          } else {
            console.error("Could not get costs: ", result.err);
            handleUpdateFinish(true);
          }
        }
      }).catch((error) => {
        console.error(error);
        setIsLoading(false);
        setHasError(true);
        onUpdateFinish();
      });
    }
      
    return () => { didCancel = true; }
  }, [shouldUpdate]);

  const [isShowingCosts, setIsShowingCosts] = useState(false);
  useEffect(() => {
    if (shouldUpdate) {
      setIsShowingCosts(false);
      setTimeout(() => { setIsShowingCosts(true) }, TransitionConfig.slideYTransition.leaveDuration);
    }
  }, [shouldUpdate])

  const handleUpdateFinish = (didError) => {
    setIsLoading(false);
    onUpdateFinish();
    if (didError) {
      setHasError(true);
    }
  };

  useEffect(() => {
    const m = filter === 'thisMonth' ? format(Date.now(), "LLLL") : format(subMonths(Date.now(), 1), "LLLL");
    onMonthChange(m);
  }, [filter])

  return (
    <div>
      {isLoading ?
        <LoadingSpinnerAlt isFixed={true}/>
        : hasError ?
          <p className={"text-black text-center pt-3"}>An error occurred</p>
          : (
            <TransitionSlideUp
              show={isShowingCosts}
              enterTime={TransitionConfig.slideYTransition.enterDuration}
              leaveTime={TransitionConfig.slideYTransition.leaveDuration}
            >
              { costItems.length > 0 ? (
                  <ul>
                    {costItems.map((item) => (
                      <li key={item.id}>
                        <CostItem costItem={item} onShow={onShowCost}/>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className={"mt-3 text-black text-center"}>No cost items to display</p>
                )}
            </TransitionSlideUp>
          )
      }
    </div>
  )
}